import { render, staticRenderFns } from "./UpdateWatch.vue?vue&type=template&id=404059e4&scoped=true"
import script from "./UpdateWatch.vue?vue&type=script&lang=js"
export * from "./UpdateWatch.vue?vue&type=script&lang=js"
import style0 from "./UpdateWatch.vue?vue&type=style&index=0&id=404059e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404059e4",
  null
  
)

export default component.exports